import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import SEO from '../components/SEO';
import { PhoneCompare } from '../components/PhoneCompare/PhoneCompare';
import '../fragments/catalog-phone-detail';
import '../fragments/plan-detail';
import { useGatsbyInit } from '../hooks/useGatsbyInit';
import { CatalogSkeletonLoader } from '../components/PhoneCatalog/SkeletonLoader';
import useTranslate from '../hooks/useTranslation';

const CisPhonesComparePage = ({ data }) => {
  const { t } = useTranslate();
  const { isInit } = useGatsbyInit();

  return (
    <>
      <SEO
        title={t('COMPARE_PAGE_TITLE')}
        description={t('SEO_COMPARE_DESCRIPTION')}
        pageTitle={t('COMPARE_PAGE_TITLE')}
      />
      {isInit ? (
        <PhoneCompare data={data} isCisPage={true} />
      ) : (
        <CatalogSkeletonLoader />
      )}
    </>
  );
};

CisPhonesComparePage.propTypes = {
  data: PropTypes.object
};

export default CisPhonesComparePage;

export const query = graphql`
  {
    allPhone {
      edges {
        node {
          ...CatalogPhoneDetailFragment
        }
      }
    }
    allPlan(filter: { enabledOnPhoneDetail: { eq: true } }) {
      edges {
        node {
          ...PlanDetailFragment
        }
      }
    }
    allPlanGroup(filter: { segment: { in: "cis" } }) {
      edges {
        node {
          defaultPlan
          groupName
          groupDisplayName
        }
      }
    }
  }
`;
